import NameTranslationMapper from "../../core/service/translations/NameTranslationMapper";
import { formatBooleanValue } from "../../util";
import OrganisationIndexGroup from "../model/OrganisationIndexGroup";
import OrganisationIndexMapper from "./OrganisationIndexMapper";

const OrganisationIndexGroupMapper = (item: any) => {
  let organisationIndexGroup = OrganisationIndexGroup(item);
  organisationIndexGroup.valid = formatBooleanValue(item.valid);
  organisationIndexGroup.harmonized = formatBooleanValue(item.harmonized);
  organisationIndexGroup.organisationIndexList = (
    item.organisationIndexList || []
  ).map(OrganisationIndexMapper);
  organisationIndexGroup.nameTranslations = (item.nameTranslations || []).map(
    (elem) => NameTranslationMapper(elem)
  );
  return organisationIndexGroup;
};

export default OrganisationIndexGroupMapper;
